import './product-support-result.scss';

import { TabBar } from '../../../components/tab-bar/tab-bar';
import { smoothScrollTo } from '../../../js/helper';

class ProductSupportResult {
    constructor (element, options) {
        this.$productSupportResult = element;
        this.$tabBar = this.$productSupportResult.querySelector('[data-tab-bar-root="product-support"]');

        this.initContent = options.initContent;
        this.resizeHandler = options.resizeHandler;

        this.firstInit = true; // prevent binding events twice on initial load
    }

    init () {
        if (this.$tabBar) {
            this.tabBar = new TabBar({
                $tabBar: this.$tabBar,
                resizeHandler: this.resizeHandler,
                initContent: ($content) => {
                    this.initSubModules($content);
                }
            });
            this.tabBar.init();
        }
        this.initSubModules(this.$productSupportResult);
        this.accordionHiddenListItemsHeight();
        this.accordionEvents();
        this.hideToggleButton();
    }

    // init different sub modules here
    initSubModules ($content) {
        // init standard content modules
        if (!this.firstInit) {
            if (typeof this.initContent === 'function') {
                this.initContent($content);
            } else {
                import('../../../pages/product-support/product-support-page').then(() => {
                    window.initSupportContent($content);
                });
            }
        }
        this.firstInit = false;

        const $productTable = $content.querySelector('[data-product-table]');
        if ($productTable) {
            import('./product-support-result-table').then(({ ProductSupportResultTable }) => {
                const productTable = new ProductSupportResultTable($content);
                productTable.init();
            });
        }
    }

    accordionHiddenListItemsHeight () {
        const $tabBarItems = this.$productSupportResult.querySelectorAll('.tab-bar__item');
        if ($tabBarItems.length > 0) {
            for (let i = 0; i < $tabBarItems.length; i++) {
                const $tabBarItem = $tabBarItems[i];

                $tabBarItem.addEventListener('click', () => {
                    const $tabContent = this.$productSupportResult.querySelector('.product-support-result__content');

                    const $accordionButtons = $tabContent.querySelectorAll('.product-support-accordion-toggle-button');
                    for (let j = 0; j < $accordionButtons.length; j++) {
                        const $accordionButton = $accordionButtons[j];
                        this.toggleAccordion($accordionButton);
                    }
                    const $accordions = $tabContent.querySelectorAll('[data-accordion]');
                    if ($accordions.length > 0) {
                        import('../../../components/accordion/accordion').then(({ Accordion }) => {
                            for (let i = 0; i < $accordions.length; i++) {
                                const $accordion = $accordions[i];

                                const accordionAPI = new Accordion($accordion);
                                $accordion.API = accordionAPI;
                            }
                        });
                    }

                    this.hideToggleButtonInTabContent();
                });
            }
        }
    }

    accordionEvents () {
        const $accordionButtons = this.$productSupportResult.querySelectorAll('.product-support-accordion-toggle-button');
        if ($accordionButtons.length > 0) {
            for (let i = 0; i < $accordionButtons.length; i++) {
                const $accordionButton = $accordionButtons[i];
                this.toggleAccordion($accordionButton);
            }
        }
    }

    toggleAccordion ($accordionButton) {
        $accordionButton.addEventListener('click', () => {
            const $resultTableContent = $accordionButton.closest('.product-support-accordion-container');
            let $accordionContentAfter = null;
            let $tableHiddenList = null;
            let $tableHiddenListInner = null;
            if ($resultTableContent) {
                $accordionContentAfter = $resultTableContent.querySelector('.product-support-result__table-children');
                $tableHiddenList = $resultTableContent.querySelector('.product-support-accordion-list-hidden');
                $tableHiddenListInner = $resultTableContent.querySelector('.product-support-accordion-list-hidden-inner');
            }

            if ($tableHiddenList.offsetHeight > 0) {
                if ($accordionButton.classList.contains('has--only-hide')) {
                    $resultTableContent.querySelector('.product-support-accordion-toggle-button:not(.has--only-hide):not(.show-four)').classList.remove('is--opened');
                } else {
                    $accordionButton.classList.remove('is--opened');
                }

                $tableHiddenList.style.maxHeight = '0';

                if ($accordionContentAfter) {
                    const accordionContentAfterHeight = $accordionContentAfter.firstElementChild.offsetHeight;
                    $accordionContentAfter.style.maxHeight = accordionContentAfterHeight + 'px';
                    setTimeout(() => {
                        $accordionContentAfter.style.maxHeight = '0';
                    }, 100);
                }

                const $accordionContainer = $accordionButton.closest('.accordion__item');
                const accordionContainerTop = $accordionContainer.getBoundingClientRect().top + window.scrollY;
                let positionTop = accordionContainerTop;
                const $header = document.querySelector('[data-header="root"]');
                if ($header) {
                    positionTop = positionTop - $header.offsetHeight;
                }
                smoothScrollTo(0, positionTop, 500);
            } else {
                $accordionButton.classList.add('is--opened');
                $tableHiddenList.style.maxHeight = $tableHiddenListInner.offsetHeight + 'px';

                if ($accordionContentAfter) {
                    const accordionContentAfterHeight = $accordionContentAfter.firstElementChild.offsetHeight;
                    $accordionContentAfter.style.maxHeight = accordionContentAfterHeight + 'px';
                    setTimeout(() => {
                        $accordionContentAfter.style.maxHeight = 'none';
                    }, 500);
                }
            }
        });
    }

    hideToggleButton () {
        // hide toggle button for product support result overview if less than 5 list elements
        const $productSupportResultOverview = this.$productSupportResult.querySelector('.product-support-result__overview');
        if ($productSupportResultOverview) {
            const $listItems = $productSupportResultOverview.querySelectorAll('.product-support-result__overview-item');
            const $toggleButton = $productSupportResultOverview.querySelector('.product-support-accordion-toggle-button');

            if ($listItems.length < 5) {
                $toggleButton.classList.add('is--hidden');
            }
        }
    }

    hideToggleButtonInTabContent () {
        // hide toggle button for product support tab content if less than 2 list items
        const $productSupportTabItems = this.$productSupportResult.querySelectorAll('.tab-bar__content-item');
        if ($productSupportTabItems.length > 0) {
            for (let i = 0; i < $productSupportTabItems.length; i++) {
                const $tabItem = $productSupportTabItems[i];
                const $tabItemTables = $tabItem.querySelectorAll('.product-support-result__table-list');

                if ($tabItemTables.length > 0) {
                    for (let j = 0; j < $tabItemTables.length; j++) {
                        const $tabItemTable = $tabItemTables[j];
                        const $tabItemTableListItems = $tabItemTable.querySelectorAll('.product-support-result__table-item');
                        const $toggleButton = $tabItem.querySelector('.product-support-accordion-toggle-button');
                        if ($tabItemTableListItems.length < 1) {
                            $toggleButton.classList.add('is--hidden');
                        }
                    }
                }
            }
        }
    }
}

export { ProductSupportResult };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productSupportResult = $context.querySelector('[data-product-support-result="root"]');

        if ($productSupportResult) {
            const productSupportResult = new ProductSupportResult($productSupportResult, {
                initContent: window.initSupportContent,
                resizeHandler: window.resizeHandler
            });
            productSupportResult.init();
        }
    }
});
